
export const text = `[ID: A shaky photo of a tree. The photo is blurry here and there, as if taken by someone not used to taking pictures. There are three people riding on each other’s shoulders. The tallest one is carrying the blond-haired one, and the smallest one stands on top of his shoulders. They appear to be trying to grab a frisbee stuck on a tree branch.]



`